module.exports = __webpack_public_path__ + "media/images/no_contracts-86d44f3869bbc4938ebf0d5cb7d3453c.svg";